// 管理端
import request from "@/utils/request";
//获取是否已有数据
export function markCountAvatar() {
  return request({
    url: "/avatar/markCountAvatar",
    method: "get",
  });
}
//获取创作记录
export function pageTalkingVideo(data) {
  return request({
    url: "/talkingVideo/pageTalkingVideo",
    method: "post",
    data,
  });
}
//获取单条创作记录
export function getTalkingVideoOne(data) {
  return request({
    url: "/talkingVideo/getTalkingVideoOne",
    method: "get",
    params: data,
  });
}
//是否是会员
export function getUserIsMember() {
  return request({
    url: "/member/getUserIsMember",
    method: "get",
  });
}
//获取出镜形象
export function pageAvatarInfo(data) {
  return request({
    url: "/avatar/pageAvatarInfo",
    method: "post",
    data,
  });
}
//删除形象
export function deleteAvatarById(data) {
  return request({
    url: "/avatar/deleteAvatarById",
    method: "get",
    params: data,
  });
}
//获取声音列表
export function queryVoice(data) {
  return request({
    url: "/voice-clone/queryVoice",
    method: "post",
    data,
  });
}
//删除声音
export function deleteVoice(id) {
  return request({
    url: `/voice-clone/deleteVoice/${id}`,
    method: "get",
  });
}
//上传音频/视频
export function voUpload(data) {
  return request({
    url: "/voice-upload/voUpload",
    method: "post",
    data,
    headers: {
      "Content-Type": "multipart/form-data", // 上传文件通常需要这个
    },
  });
}


//获取已上传文件
export function queryVoUploadInfo(data) {
  return request({
    url: "/voice-upload/queryVoUploadInfo",
    method: "post",
    data,
  });
}
//删除临时文件
export function voDelete(fileId) {
  return request({
    url: `/voice-upload/voDelete/${fileId}`,
    method: "get",
  });
}
//上传声音文件
export function createFile(data) {
  return request({
    url: "/voice-clone/create",
    method: "post",
    data,
  });
}
//上传形象文件
export function addAvatar(data) {
  return request({
    url: "/avatar/addAvatar",
    method: "post",
    data,
  });
}

//修改形象名称
export function editAvatar(data) {
  return request({
    url: "/avatar/editAvatar",
    method: "post",
    data,
  });
}
//修改声音名称
export function updateVoice(data) {
  return request({
    url: "/voice-clone/updateVoice",
    method: "post",
    data,
  });
}
//上传爆款改写文件

export function addhitVideo(data) {
  return request({
    url: "/hitVideo/upload",
    method: "post",
    data,
    // headers: {
    //   "Content-Type": "multipart/form-data", // 上传文件通常需要这个
    // },
  });
}
export function createTHVideo(data) {
  return request({
    url: "/videoRetalk/createTHVideo",
    method: "post",
    data,
  });
}
//获取已有形象/声音
export function queryVoCount() {
  return request({
    url: "/voice-clone/queryVoCount",
    method: "get",
  });
}


export function convertWebmToMp4(data,config = {}) {
  return request({
    url: "/voice-upload/convertWebmToMp4",
    method: "post",
    data,
    headers: {
      "Content-Type": "multipart/form-data", // 上传文件通常需要这个
    },
    ...config,
  });
}

export function aiVideo() {
  return request({
    url: "/check/ai-video",
    method: "post",
  });
}

